
import { Button, Col, Form, Icon, Row, Spin, Table, Checkbox } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import iconStyle from '../components/icon.cs';
import { getStringSorter, getBooleanSorter } from '../utils/antUtils';
import { getPageSize } from '../utils/paging';
import styles from './eliterature.css';
import { fetchELiterature, save } from './eliteratureActions';


const { Column } = Table;
const CheckboxGroup = Checkbox.Group;


class ELiteratureComponent extends Component {


  state = {
    selected: [],
    loaded: false
  }

  componentDidMount() {
    this.props.dispatch(fetchELiterature(this.props.match.params.id));
  }

  componentDidUpdate() {

    if (this.state.loaded) {
      return;
    }

    if (this.props.list.length > 0) {
      this.setState({
        loaded: true,
        selected: this.props.list.filter((b) => b.access).map(b => b.id)
      })
    }
  }

  onChange = (selected) => {

    this.setState({
      selected
    });

    this.props.dispatch(save(this.props.match.params.id, selected));
  }

  render() {


    let data = this.props.list || [];

    let books = data.map((book) => ({ label: book.title, value: book.id }));

    return (<div>

      <Row style={{ marginBottom: 20 }}>
        <Col span={12}>
          <h2>{this.props.orgName} tillgång till E-litteratur</h2>
        </Col>        
      </Row>

      <Spin spinning={this.props.loading}>
        <Row className='eliteratureSelector'>
          <CheckboxGroup options={books} value={this.state.selected} onChange={this.onChange} />
        </Row>
      </Spin>

    </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    orgId: state.eliterature.orgId,
    orgName: state.eliterature.orgName,
    list: state.eliterature.list,
    loading: state.eliterature.loading,
    filter: state.eliterature.filter
  }
};

export default connect(mapStateToProps)(Form.create()(ELiteratureComponent));


// WEBPACK FOOTER //
// ./src/eliterature/eliteratureComponent.js